import script from "./BikeSPForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BikeSPForm.vue?vue&type=script&setup=true&lang=js"

import "./BikeSPForm.vue?vue&type=style&index=0&id=5b22ae89&lang=css"

const __exports__ = script;

export default __exports__